module.exports = __webpack_public_path__ + "static/media/shapes-line.f47bae6c.svg";